<template>
  <form-layout class="col-span-2 h-full">
    <template v-slot:title>
      {{ $t("testfleet.booking.bikeDetail.title") }}
    </template>

    <template v-slot:description>
      {{ $t("testfleet.booking.bikeDetail.description") }}
    </template>
    <template v-slot:form>
      <div class="space-y-8 pb-12 lg:pb-0 px-8">
        <BikeInfoCardSkeleton class="mt-4" />
        <div>
          <div class="pb-3">
            <h3 class="leading-[48px]">
              {{ $t("testfleet.booking.bikeDetail.availability") }}
            </h3>
            <span class="font-roboto text-neutral-700 leading-5 text-sm !font-normal">
              {{ $t("testfleet.booking.bikeDetail.availabilityDescription") }}
            </span>

          </div>
          <Skeleton height="15rem" class="mt-2" />
        </div>
      </div>
    </template>
  </form-layout>

</template>

<script lang="ts" setup>
import Skeleton from "primevue/skeleton";
import BikeInfoCardSkeleton from "@/components/BikeInfoCard/BikeInfoCardSkeleton.vue";
import FormLayout from '@/components/Form/FormLayout.vue'

</script>
